import ApiError from 'interfaces/ApiError';
import ApiResponse from 'interfaces/ApiResponse';

export default function createApiResponse<T>(
  isSuccessfull: boolean,
  data: T,
  status: number | null,
  error: ApiError | null = null
): ApiResponse<T> {
  return {
    isSuccessfull,
    data,
    status,
    error
  };
}
